export default {"src":"/_next/static/media/close-grey.78e9555a.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};